import axios from '~/common/plugins/axios.js'
// 后台商户相关的接口数据暂存，目前只用于分派下拉 20201022
export const state = () => ({
  shopList: [],
});

export const mutations = {
  set_shop_list(state, v) {
    state.shopList = v;
  },
};

export const actions = {
  // 获取所有商户
  async getShopList({ state, commit }, params) {
    let url =''
    let p = {}
    if(process.client) {
      let path = window.location.pathname
      if(/\/erp\//.test(path)) {
        url = '-admin'
        p = {}
      } else {
        url = ''
        p = { //前台需要加这个参数
          for_assign: true
        }
      }
    }
    if (state.shopList.length > 0 && state.currentType === url) {
      return state.shopList;
    } else {
      const { code, data } = await axios.$post(`/rest/${url==="-admin"?"erp":"store"}/contact/v3/contactshopsidnamelist`, {...params, ...p});
      if (code !== 200) return [];
      const shopList = data.list;
      commit("set_shop_list", {shopList, currentType: url});
      return shopList;
    }
  },
};
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
